<iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4024.617453173592!2d80.66587977536402!3d16.506954884237828!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fad1a1fee591%3A0xa916997526ac2b4a!2s8th%20Cross%20Rd%2C%20Vijayawada%2C%20Andhra%20Pradesh%20520008!5e1!3m2!1sen!2sin!4v1741185217460!5m2!1sen!2sin"
  width="100%"
  height="450"
  style="border: 0"
  allowfullscreen=""
  loading="lazy"
  referrerpolicy="no-referrer-when-downgrade"
></iframe>
<div class="container-fluid w-page">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 contact-us-h">
        <div class="row">
          <h3 class="page-heading">Contact Us</h3>
        </div>
        <h4>Address</h4>
        <div style="line-height: 20px">
          Road No:8, Bharathi Nagar,<br />
          Gurunanak Colony, <br />Vijayawada- 520008, AP, India.
        </div>
        <h4 class="mt-4">Phone</h4>
        <div style="line-height: 20px">
          +91 960357 5555<br />
          +91 9667 097777
        </div>
        <h4 class="mt-4">e-mail</h4>
        <div>
          <a href="mailto:sivanathk&#64;gmail.com" class="link"
            >sivanathk&#64;gmail.com</a
          >
        </div>
      </div>
      <div class="col-lg-6 m-mt-50">
        <form
          [formGroup]="contactForm"
          style="margin: auto"
          (ngSubmit)="updateContactForm()"
        >
          <div class="row">
            <h3 class="page-heading">Reach Us</h3>
          </div>
          <div class="form-set">
            <label for="Name" class="formbuilder-select-label form-label"
              >Name</label
            >
            <input
              class="p-inputtext"
              type="text"
              pInputText
              formControlName="Name"
            />
          </div>
          <div class="form-set">
            <label for="e-mail" class="formbuilder-select-label form-label"
              >e-mail</label
            >
            <input
              class="p-inputtext"
              type="text"
              pInputText
              formControlName="DonorsEmail"
            />
          </div>
          <div class="form-set">
            <label for="Subject" class="formbuilder-select-label form-label"
              >Subject</label
            >
            <input
              class="p-inputtext"
              type="text"
              pInputText
              formControlName="Subject"
            />
          </div>
          <div class="form-set">
            <label for="Message" class="formbuilder-select-label form-label"
              >Message</label
            >
            <textarea
              formControlName="Message"
              class="p-inputtext"
              rows="4"
              cols="50"
            ></textarea>
          </div>
          <div class="tab-footer-btns mt-4">
            <button
              type="button"
              label="Cancel"
              class="cancel-btn-m"
              (click)="cancelForm()"
            >
              Cancel
            </button>

            <p-button
              label="Submit"
              type="submit"
              class="submit-btn"
              [disabled]="!contactForm.valid"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="ep-footer">
  <div class="container">
    <div class="d-flex jusify-space-between">
      <div class="d-flex flex-column">
        <h3>Help</h3>
        <div style="line-height: 20px">
          <div>+91 9288227228</div>
          <div>
            <a href="mailto:info&#64;empowerandhra.com" class="link"
              >info&#64;empowerandhra.com</a
            >
          </div>
        </div>
      </div>
      <div class="d-flex flex-column follow-us-img">
        <h3>Follow us</h3>
        <div class="d-flex gap-3">
          <img src="assets/images/icon-whatsapp.png" />
          <img src="assets/images/icon-facebook.png" />
          <img src="assets/images/icon-instagram.png" />
          <img src="assets/images/icon-twitter.png" />
          <img src="assets/images/icon-youtube.png" />
        </div>
      </div>
    </div>
    <hr />
    <div class="d-flex jusify-space-between">
      <div class="d-flex footer-copyrights">
        <div>2025 © Empower Andhra</div>
        <div><a href="#">Terms of Service</a></div>
        <div><a href="#">Privacy Policy</a></div>
      </div>
      <div>Site last updated on: 12-APR-2025</div>
    </div>
  </div>
</div>
